import Component from "../../lib/component";
import iconForwardChevron from "./assets/icon__forward_chevron.svg"
export const CollapserConfig = {
    componentTypeKey: 'CollapserToggle',
    baseHtmlClass: 'collapser_toggle',
    selector: '.collapser_toggle',
    datasetConfigKey: 'collapser_toggle',
};

export class CollapserToggle extends Component {

    static get config() {
        return CollapserConfig;
    }

    constructor(id_or_element, collapser) {
        super({
            element: id_or_element,
            config: CollapserToggle.config
        });

        this.setDatasetConfig(CollapserToggle.config.datasetConfigKey);

        this.collapser = collapser;

        this.buttonElement = createButtonElement(this);

        this.element.addEventListener('click', this.handleLinkClick.bind(this));

        this.render();
    }


    handleLinkClick(e) {
        this.collapser.toggleOpen(this);
        this.collapser.render();
        e.preventDefault();
    }

    isOpen() {
        return this.collapser.isOpen;
    }

    isCollapsable() {
        return this.collapser.isCollapsable;
    }

    render() {
        this.conditionallySetHtmlClassState(this.isCollapsable(), 'collapsable');
        this.swapHtmlClassStates(this.isOpen(), 'open', 'closed');
    }

}


function createButtonElement(collapserToggle) {
    const element = document.createElement('button');
    element.classList.add('collapser_toggle__icon');
    const svgElement = new DOMParser().parseFromString(iconForwardChevron, "image/svg+xml").documentElement;
    svgElement.style.cssText = "display:block;height:100%;width:100%;";
    element.appendChild(svgElement);
    collapserToggle.element.appendChild(element);
    return element;
}